import { fontSize, nearbyProfileScrollerTop, size } from '@styles/theme'
import styled from '@emotion/styled'
import clamp from 'clamp-js'

import AtAGlanceDetails from './AtAGlanceDetails'
import { TbNews } from 'react-icons/tb'

const Container = styled.div`
  width: 100%;
  height: ${nearbyProfileScrollerTop};
  overflow: hidden;
`

const TabHrOuter = styled.div`
  padding: ${size(2)};
  padding-bottom: ${size(1.5)};
`

const TabHrInner = styled.div`
  width: ${size(6)};
  height: 4px;
  background-color: rgba(255,255,255, 0.15);
  border-radius: 100px;
  margin: 0 auto;
`

const Title = styled.b`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-left: ${size(3)};
  margin-bottom: ${size(0.5)};
  color: rgba(255,255,255,0.8);
`

const Contents = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 ${size(5)} 0 ${size(3)};
  overflow: hidden;
  -webkit-box-align: center !important;
  font-size: ${fontSize('sm')};
  font-weight: 600;
  word-spacing: ${size(2)};
  line-height: ${size(2.25)};
  color: rgba(255,255,255,0.8);
`

const AskMe = styled.h3`
  display: flex;
  justify-content: center;
  margin-top: ${size(3.5)};

  font-size: ${fontSize('md')};
  font-weight: 600;
  color: rgba(255,255,255,0.8);
`

const PostCount = styled.span`
  display: flex;
  align-items: center;
`

const registeredIndicator = { 
  style: {
    marginBottom: '-2px',
    opacity: '0.8',
  }
}

const ProfileAtAGlance = ({ user, userHasAtAGlance,  postCount=0 }) => {

  const renderPostCount = () => (
    <PostCount>
      &nbsp;-&nbsp;
      <TbNews strokeWidth='2.5px' style={{ marginTop: -1 }} />
      &nbsp;{`${postCount} ${postCount === 1 ? 'Post' : 'Posts'}`}
    </PostCount>
  )

  const renderAtAGlance = () => (
    <>
      <Title>Brief{postCount > 0 && renderPostCount()}</Title>
      <Contents
        // TODO: see if this -webkit-box-align is doing anything...
        style={{ '-webkit-box-align': 'center' }}
        ref={node => node && clamp(node, { clamp: 3 })}>
        <AtAGlanceDetails user={user} slots={{ registeredIndicator }} capitalizeEach />
      </Contents>
    </>
  )

  return (
    <Container>
      <TabHrOuter>
        <TabHrInner />
      </TabHrOuter>
      {userHasAtAGlance
        ? renderAtAGlance()
        : <AskMe>Ask me, to learn more 🙂</AskMe>
      }
    </Container>
  )
}

export default ProfileAtAGlance
